'use client';

import { useEffect } from 'react';

/**
 * Instrumente les chemins de conversion qui n'etaient pas mesures :
 * clics WhatsApp, clics email, et reservations Cal.com.
 *
 * Le formulaire de contact envoie deja `cindy_contact_submit` depuis ContactForm.
 * Pose une seule fois dans le layout marketing, ce composant couvre toutes les pages
 * par delegation d'evenements, sans modifier chaque lien.
 */
export default function ConversionTracking() {
  useEffect(() => {
    const push = (action: string, label: string) => {
      const paq = (window as unknown as { _paq?: Array<unknown[]> })._paq;
      paq?.push(['trackEvent', 'Lead', action, label]);
    };

    // 1. Clics sortants WhatsApp et email, sur n'importe quelle page
    const onClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement | null;
      const link = target?.closest?.('a');
      if (!link) return;
      const href = link.getAttribute('href') ?? '';
      const page = window.location.pathname;
      if (href.startsWith('https://wa.me/')) push('cindy_whatsapp_click', page);
      else if (href.startsWith('mailto:')) push('cindy_email_click', page);
    };
    document.addEventListener('click', onClick, { capture: true });

    // 2. Reservation aboutie dans le widget Cal.com (iframe, via postMessage)
    const onMessage = (e: MessageEvent) => {
      if (!e.origin.includes('cal.com')) return;
      let type: string | undefined;
      try {
        const d = typeof e.data === 'string' ? JSON.parse(e.data) : e.data;
        type = d?.type ?? d?.action;
      } catch {
        return;
      }
      if (type === 'bookingSuccessful' || type === 'bookingSuccessfulV2') {
        push('cindy_cal_booking', window.location.pathname);
      }
    };
    window.addEventListener('message', onMessage);

    return () => {
      document.removeEventListener('click', onClick, { capture: true });
      window.removeEventListener('message', onMessage);
    };
  }, []);

  return null;
}
